// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap__kPXgw","left":"index_left__mdg5K","name":"index_name__c6FdL"};